import type { ComponentStyleConfig } from "@chakra-ui/theme";
import { textStyles } from "theme/text-styles";

export const Link: ComponentStyleConfig = {
  baseStyle: {
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    whiteSpace: "pre-wrap",
    fontWeight: "semibold",
    borderRadius: "tinier", // Gives a friendly rounded focus border
    _hover: {
      textDecoration: "none",
    },
    _focus: {
      outline: "none !important",
    },
    _active: {
      outline: "none !important",
    },
    _focusVisible: {
      borderColor: "transparent",
      boxShadow: "outline",
    },
  },
  sizes: {
    xs: {
      fontSize: "xs",
    },
    sm: {
      fontSize: "sm",
    },
    md: {
      fontSize: "md",
    },
    lg: {
      fontSize: "lg",
    },
    xl: {
      fontSize: "xl",
    },
  },
  variants: {
    inline: {
      position: "relative",
      display: "inline",
      fontSize: "inherit",
      fontWeight: "inherit",
      color: "new.green.700",
      textDecoration: "underline",
      textUnderlineOffset: "4px",
      _hover: {
        color: "unset",
        textDecoration: "underline",
      },
    },
    inlineDark: {
      position: "relative",
      display: "inline",
      fontSize: "inherit",
      fontWeight: "inherit",
      textDecoration: "underline",
      textUnderlineOffset: "4px",
      _hover: {
        color: "new.green.700",
        textDecoration: "underline",
      },
    },
    nav: {
      ...textStyles.caption1,
      borderRadius: "base",
      fontWeight: "normal",
      pos: "relative",
      w: "100%",
      height: "100%",
      userSelect: "none",
    },
    navMobile: {
      ...textStyles.headline2,
      fontWeight: "semibold",
      py: "smallest",
    },
    footer: {
      ...textStyles.caption2,
      display: "flex",
      alignItems: "center",
      color: "brand.text.dark",
      gap: "tiny",
      fontWeight: "semibold",
      "& span, & svg": {
        opacity: 0.7,
        transition: ".15s ease-out",
      },
      _hover: {
        "& span, & svg": {
          opacity: 1,
        },
      },
      _focusVisible: {
        "& span, & svg": {
          opacity: 1,
        },
      },
    },
    sidebar: {
      ...textStyles.caption1,
      borderRadius: "tiny",
      color: "brand.textSecondary.light",
      fontWeight: "normal",
      my: "tiniest",
      px: "tiny",
      py: "tinier",
      _hover: { bg: "brand.backgroundSecondary.light", color: "brand.text.light" },
      transition: ".15s ease-out",
      transitionProperty: "background-color, color",
      "&[data-active='true']": {
        bg: "new.green.50",
        color: "brand.text.light",
      },
    },
    unstyled: {
      textDecoration: "none",
      fontWeight: "normal",
      fontSize: "base",
      _hover: {
        textDecoration: "none",
      },
    },
    breadcrumb: {
      color: "inherit",
      fontSize: "inherit",
      fontWeight: "inherit",
      lineHeight: "inherit",
      textDecoration: "none",
      textUnderlineOffset: "3px",
      transition: ".15s ease-out",
      transitionProperty: "color, text-decoration",
      _hover: { textDecoration: "underline", color: "brand.text.light" },
    },
    shadowCard: {
      _focusVisible: {
        boxShadow: "linkCardOutline",
      },
    },
  },
};
